var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',_vm._l((_vm.event.games),function(game,i){return _c('ReportEventDialogGameTableRow',{key:i,attrs:{"event":_vm.event,"game":game},on:{"remove-game":_vm.onRemoveGame,"game-count-changed":_vm.onGameCountChanged}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }